import React, { Component } from 'react';
import { Trans, Translation, withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Nav, NavItem, NavLink, Form } from 'reactstrap';
import { mapStateToProps } from '../../redux/selector/selector';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import MainLayout from '../../layout/MainLayout';
import MessagePopUp from '../../components/MessagePopUp';
import FormPopUp from '../../components/FormPopUp';
import SVGMyAcc from '../../components/Icon/SVGMyAcc';
import SVGMaster from '../../components/Icon/SVGMaster';
import SmallLoading from '../../components/Loading/SmallLoading';
import { IoMdArrowRoundDown } from 'react-icons/io';
import Loading from '../../components/Loading/Loading';
import { providerIcon } from '../16MyAccount/161_MyAccount_Items_Data';
import { MdClose } from 'react-icons/md';
import notification from 'root/utils/notification';
import commonUtil from 'root/utils/common-util';
import core from 'root/utils/core';
import moment from 'moment';
import Countdown, { zeroPad } from 'react-countdown-now';
import { withRouter } from 'react-router-dom';
import { floatingAction } from 'root/redux/action';

// This component shows the items user checked out from the cart.
class Promotion extends Component {
    isMount = true;
    constructor(props) {
        super(props);
        this.state = {
            promotionList: [],
            activeTab: 'ALL',
            detailModal: false,
            formModal: false,
            loginModal: false,
            msgTitle: '',
            msgContent: '',
            applyContent: [],
            transModal: false,
            dropDown: false,
            mainWallet: null,
            promotionObj: null,
            transferAmount: 0,
            providerList: [],
            providerWalletsList: [], // same to providerList, just this var is for providerWallet fields
            supportLinkPromotion: false,
            restoreOnLoad: false,
            selectedProvider: null,
            currentDomainPath: '',
            isPopUp: false,
            message: '',
            status: '',
            floatingNotificationId: null,
            merchantLiveChat: '',
        };
        this.toggle = this.toggle.bind(this);
        this.toggleDetailModal = this.toggleDetailModal.bind(this);
        this.toggleFormModal = this.toggleFormModal.bind(this);
        this.renderCountdown = this.renderCountdown.bind(this);
    }

    onTabClick(index) {
        let promotionTypes = this.state.promotionList.promotionTypes;
        let promotionType = promotionTypes[index].promotionType;
        this.getPromotionContent(promotionType);
        this.setState({ activeTab: promotionType });
    }

    handleTabClick = (event) => {
        this.setState({ activeTab: event.target.id });
    };

    componentDidMount() {
        this.isMount = true;
        const { account } = this.props.user;
        if (account) {
            this.getCountryInfo();
            this.initInfo();
        }
        commonUtil.loadCustomTranslation('Promotion', this, function () {});
        this.initCompSettings().then(() => {
            this.getPromotionContent('all');
            this.getMerchantLiveChat();
        });

        this.checkSupportLinkPromotionEnabled();
        this.getFloatNotificationId();
        this.setState({ currentDomainPath: this.props.history.location.pathname });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.screen.isMobile !== this.props.screen.isMobile) {
            this.getPromotionContent('all');
        }
    }

    initCompSettings() {
        return new Promise((resolve) => {
            // Step 1: Standard way to get from portal settings
            let tempSettings = commonUtil.getSettingFromPortalSettings({
                vm: this,
                settingName: 'promotionSettings',
                isCurrencyLang: true,
            });

            // Step 2: Massage again to get the specific data you need (Skip if not needed)

            // Step 3: Initial all into compSettings
            let compSettings = {
                promotionSettings: tempSettings,
            };

            this.setState({ compSettings: compSettings }, () => {
                resolve();
            });
        });
    }

    initInfo = () => {
        let phone = '';
        const { account } = this.props.user;

        if (account && account.phone) {
            phone = account.phone.substring(3);
        }

        this.setState({ name: account.name, email: account.email, phone: phone });
    };

    getCountryInfo() {
        const { user } = this.props;

        window.SPL_Content.getCountryInfo().then((telCodeList) => {
            if (this.isMount) {
                const { language } = this.props;
                let selectedObj = {};
                let phone = user.account.phone;
                if (phone && phone.length > 0) {
                    let telCode = phone.substring(0, 3);
                    selectedObj = this.getCountryCode(telCodeList, telCode);
                    if (selectedObj === null) {
                        selectedObj = this.getSelectedObj(telCodeList, language.country);
                    }
                } else {
                    selectedObj = this.getSelectedObj(telCodeList, language.country);
                }
                this.setState({
                    telCodeList: telCodeList,
                    telCode: selectedObj.telCode,
                    countryCode: selectedObj.countryCode,
                    currency: selectedObj.currency,
                });
            }
        });
    }

    getCountryCode = (telCodeList, telCode) => {
        if (telCode.length > 0) {
            let telCodeNum = telCode.split('+')[1];
            for (let i = 0; i < telCodeList.length; i++) {
                const telCodeObj = telCodeList[i];
                if (telCodeObj.telCode === telCodeNum + '') {
                    let returnObj = {
                        telCode: `+${telCodeObj.telCode}`,
                        countryCode: telCodeObj.country,
                        currency: telCodeObj.currency,
                    };
                    return returnObj;
                }
            }
            return null;
        }
        return null;
    };

    getSelectedObj(telCodeList, country) {
        let returnObj = {};
        for (let i = 0; i < telCodeList.length; i++) {
            const telCodeObj = telCodeList[i];
            if (telCodeObj.country === country) {
                returnObj = {
                    telCode: `+${telCodeObj.telCode}`,
                    countryCode: telCodeObj.country,
                    currency: telCodeObj.currency,
                };
            }
        }
        return returnObj;
    }

    toggleDetailModal = (info) => {
        const { detailModal } = this.state;
        const isModalOpening = !detailModal;

        if (commonUtil.getIsZT828LiteApp()) {
            if (isModalOpening) {
                window.SPL_LiteApp.onPopOutToggle(true);
            } else {
                window.SPL_LiteApp.onPopOutToggle(false);
            }
        }

        this.setState({ detailModal: isModalOpening, loginModal: false, msgTitle: info.title, promoContent: info });

        if (isModalOpening) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }

        window.SPL_Content.loadPromotionContent(info.content).then((data) => {
            this.setState({ msgContent: data.content });
        });
    };

    toggleFormModal = (info) => {
        const { isLogin, account } = this.props.user;
        const { floatingNotificationId, merchantLiveChat } = this.state;
        const { storeNotificationId } = this.props.floatingNotification;
        let currency = '';

        this.setState({
            promotionObj: info,
            selectedProviderImage: '',
            selectedProvider: null,
            selectedProviderBalance: '',
            dropDown: false,
            targetTurnover: 0,
            bonusAmount: 0,
        });

        if (account) {
            currency = account.currency;
        }
        if (!isLogin) {
            if (this.props.screen.isMobile) {
                this.props.history.push({ pathname: '/login', state: { currentDomainPath: this.state.currentDomainPath } });
            } else {
                this.setState({ detailModal: true, loginModal: true }, () => {
                    this.loginMsg();
                });

                if (commonUtil.getIsZT828LiteApp()) {
                    window.SPL_LiteApp.onPopOutToggle(true);
                }
            }
        } else {
            if (this.state.supportLinkPromotion === true) {
                if (info.applyAction === 'REDIRECT') {
                    if (this.state.supportLinkPromotion === true) {
                        window.SPL_Content.getPromotion(info.promotionId, currency).then((data) => {
                            if (data.id) {
                                this.setState({ transModal: true });
                                this.setState({ promoDetails: data }, () => {
                                    this.getMainWallet().then(() => {
                                        this.getPromoDetails(this.state.promoDetails);
                                    });
                                });
                            } else {
                                if (this.props.screen.isMobile) {
                                    this.props.history.push('/account/transfer');
                                } else {
                                    this.props.history.push('/myaccount/transfer');
                                }
                            }
                        });
                    } else {
                        if (this.props.screen.isMobile) {
                            this.props.history.push('/account/transfer');
                        } else {
                            this.props.history.push('/myaccount/transfer');
                        }
                    }
                } else if (info.applyAction === 'FORM') {
                    this.setState({ formModal: true, loginModal: false, applyContent: info });

                    if (commonUtil.getIsZT828LiteApp()) {
                        window.SPL_LiteApp.onPopOutToggle(true);
                    }
                } else if (info.applyAction === 'DIRECT') {
                    const { user } = this.props;
                    let date = new Date();
                    let params = {
                        createdDate: date,
                        status: 'P',
                        memberId: user.account.id,
                        promotionId: info.id,
                        phone: this.state.telCode + this.state.phone,
                        name: this.state.name,
                        remark: '',
                        address: this.state.address,
                        email: this.state.email,
                        language: info.language,
                        floatingNotificationId: floatingNotificationId ? floatingNotificationId : storeNotificationId,
                    };
                    window.SPL_Member.applyPromotion(params).then((data) => {
                        if (this.isMount) {
                            if (data.success) {
                                this.setState({ status: 'S', message: 'promotion:promotion.successMsg', isPopUp: true }, () => {
                                    setTimeout(() => {
                                        this.setState({ status: '', message: '', isPopUp: false });
                                    }, 5000);
                                });
                                this.vm.props.dispatch(floatingAction.storeFloatingNotificationId(null));
                            } else {
                                this.setState({ status: 'F', message: data.errorTranslate, isPopUp: true }, () => {
                                    setTimeout(() => {
                                        this.setState({ status: '', message: '', isPopUp: false });
                                    }, 5000);
                                });
                            }
                        }
                    });
                } else if (info.applyAction === 'CONTACT_CS') {
                    if (info.isContactCSUrlNewPage) {
                        if (info.contactCSUrlType === 'N') {
                            info.contactCSUrl && window.open(info.contactCSUrl);
                        } else {
                            merchantLiveChat?.href && window.open(merchantLiveChat.href);
                        }
                    } else {
                        const { screen } = this.props;
                        const popupPosition = screen.width - 625 < 0 ? 0 : screen.width - 625;
                        if (info.contactCSUrlType === 'N') {
                            info.contactCSUrl &&
                                window.open(
                                    info.contactCSUrl,
                                    `${window.globMerchantName} 24/7 Live Chat - Pre-Chat Window`,
                                    `height=600, width=600, top=25, left=${popupPosition}`
                                );
                        } else {
                            merchantLiveChat?.href &&
                                window.open(
                                    merchantLiveChat.href,
                                    `${window.globMerchantName} 24/7 Live Chat - Pre-Chat Window`,
                                    `height=600, width=600, top=25, left=${popupPosition}`
                                );
                        }
                    }
                } else {
                    this.setState({ formModal: false, loginModal: false, applyContent: info });

                    if (commonUtil.getIsZT828LiteApp()) {
                        window.SPL_LiteApp.onPopOutToggle(false);
                    }
                }
            }
        }
    };

    getFloatNotificationId() {
        const { location, history } = this.props;

        if (location && location.search) {
            let currentUrlParams = new URLSearchParams(location.search);
            let floatingNotificationId = currentUrlParams.get('floatingNotificationId');

            if (floatingNotificationId) {
                this.setState({ floatingNotificationId: parseInt(floatingNotificationId) }, () => {
                    history.replace();
                });
            }
        }
    }

    checkSupportLinkPromotionEnabled = () => {
        window.SPL_Content.checkSupportLinkPromotionEnabled().then((data) => {
            this.setState({ supportLinkPromotion: data.data });
        });
    };

    getPromoDetails = (details) => {
        let providerList = [];
        let promotionId = null;

        const { selectedProvider } = this.state;

        if (details && details.promotion && details.promotion.providers) {
            providerList = details.promotion.providers;
            promotionId = details.promotion.id;
            if (!selectedProvider) {
                if (providerList.length > 0) {
                    let provider = providerList[0].provider;
                    this.handleProviderSelect(provider, `/public/images/promotion-transfer/${provider}.png`, provider.balance);
                }
            }
        }

        const { transferAmount, mainWallet } = this.state;
        let { min, max, turnover, bonus, newTransferAmount } = this.getTransferDetail(mainWallet, details, transferAmount);

        this.setState({
            transferSliderMin: min,
            transferSliderMax: max,
            providerList: providerList,
            promotionId: promotionId,
            transferAmount: newTransferAmount,
            targetTurnover: turnover,
            bonusAmount: bonus,
        });
    };

    getTransferDetail = (mainWallet, details, transferAmount) => {
        let rate = details.promotion.rate;

        let minTransferAmount = this.calculateTransferAmountByBonus(details.minBonus, rate);
        let maxTransferAmount = 0;
        if (mainWallet.balance < minTransferAmount) {
            minTransferAmount = 0;
            maxTransferAmount = 0;
        } else {
            let maxAmount = this.calculateTransferAmountByBonus(details.maxBonus, rate);
            if (mainWallet.balance < maxAmount) {
                //main wallet amount become max
                maxTransferAmount = mainWallet.balance;
            } else {
                // calculate max transfer amount
                maxTransferAmount = maxAmount;
            }

            // Set default Transfer Amount
            if (mainWallet.balance > minTransferAmount) {
                transferAmount = minTransferAmount;
            }

            this.calculateBonus();
        }

        let targetMultiplier = details.promotion.targetMultiplier;
        let bonus = transferAmount * rate;
        let turnover = this.rounding((parseFloat(transferAmount) + parseFloat(bonus)) * targetMultiplier);
        return { min: minTransferAmount, max: maxTransferAmount, turnover, bonus, newTransferAmount: transferAmount };
    };

    calculateBonus = () => {
        const { transferAmount } = this.state;
        const { targetMultiplier, rate } = this.state.promoDetails.promotion;
        if (this.state.promoDetails == null || transferAmount == null || rate == null || targetMultiplier == null) {
            return;
        }
        let bonus = this.rounding(transferAmount * rate);
        let turnover = this.rounding((parseFloat(transferAmount) + parseFloat(bonus)) * targetMultiplier);
        this.setState({
            targetTurnover: turnover.toFixed(2),
            bonusAmount: bonus.toFixed(2),
        });
    };

    calculateTransferAmountByBonus = (bonus, rate) => {
        var amount = this.rounding(bonus / rate);
        return amount || 0;
    };

    rounding = (amount) => {
        return Math.round(amount * 100) / 100;
    };

    requestTransfer = (provider) => {
        const { transferAmount, promotionId, selectedProvider } = this.state;
        const { t } = this.props;

        this.setState({ showLoading: true }, () => {
            if (transferAmount !== '' && promotionId !== '' && selectedProvider !== '') {
                window.SPL_Transaction.requestTransfer(transferAmount, promotionId, 'Member Deposit', selectedProvider, null).then((data) => {
                    this.setState({ showLoading: false });
                    if (data.status === 'F') {
                        if (data.msg && data.msg.data && data.msg.data.detail) {
                            notification.showNotification('error', t(data.msg.data.detail));
                        } else {
                            notification.showNotification('error', t(data.msg));
                        }
                    } else {
                        if (this.isMount) {
                            this.setState({ transModal: false, thankyouModal: true });
                            this.setState({
                                transferAmount: '',
                                promotionId: '',
                            });
                            setTimeout(() => {
                                this.getMainWallet();
                            }, 500);
                        }
                    }
                });
            }
        });
    };

    getMainWallet = () => {
        this.setState({ iconLoading: true, restoreOnLoad: true });
        let component = this;
        return new Promise(function (resolve, reject) {
            window.SPL_Member.getMainWallet()
                .then((mainWallet) => {
                    if (component.isMount) {
                        component.setState({
                            mainWallet: mainWallet.data,
                            iconLoading: false,
                            restoreOnLoad: false,
                        });
                        component.loadAsyncProviderWallet();
                        resolve(mainWallet.data);
                    }
                })
                .catch((err) => {
                    if (component.isMount) {
                        component.setState({ iconLoading: false, restoreOnLoad: false });
                    }
                });
        });
    };

    handleSliderChange = (e) => {
        this.setState({ transferAmount: e }, () => {
            this.calculateBonus();
            // this.getPromoDetails(this.state.promoDetails);
        });
    };

    loginMsg = () => {
        if (this.state.loginModal) {
            this.setState({ msgTitle: 'login:login.proceed' });
        }
    };

    getMerchantLiveChat() {
        let params = {
            language: this.props.language.countryLanguageKey,
        };

        window.SPL_Content.getMerchantContentLiveChat(params).then((res) => {
            if (res) {
                this.setState({ merchantLiveChat: res.data });
            }
        });
    }

    getPromotionContent(filter) {
        const { language, screen, user } = this.props;
        const { compSettings } = this.state;
        const { promotionSettings } = compSettings;

        // haven't got this requirement yet, but pre do first
        if (promotionSettings && promotionSettings.enableProductTypeLayer) {
            this.getPromotionContentV2(null, filter);
            return;
        }

        window.SPL_Content.getPromotionContent(language.countryLanguageKey, filter, screen.viewType).then((data) => {
            if (this.isMount) {
                let allCategory = {
                    promotionType: 'ALL',
                    desc: 'promotion:promotion.category.all',
                };
                data.promotionTypes.unshift(allCategory);
                // data.promotionTypes = data.promotionTypes.filter(this.filterPromotion);
                // data.displaypromotionContents = data.displaypromotionContents.filter(this.filterPromotion);

                let chkProviderWalletField = false;
                for (let i = 0; i < data.displaypromotionContents.length; i++) {
                    let promotionContent = data.displaypromotionContents[i];
                    if (!chkProviderWalletField && user.isLogin && promotionContent.formFields && promotionContent.formFields.includes('PROVIDER_WALLET')) {
                        chkProviderWalletField = true;
                        this.getAllProviderWallets();
                    }

                    // NOTE: end time no set mean unlimited
                    if (promotionContent && promotionContent.isRemainingTime) {
                        let endDate = promotionContent.endDate;
                        let remainingTime = endDate === null ? null : new Date(endDate);
                        if (remainingTime === null || remainingTime === '') {
                            promotionContent.remainingUnlimited = true;
                        } else {
                            promotionContent.remainingUnlimited = false;
                        }
                    }
                }
                this.setState({ promotionList: data }, () => {
                    this.showPromotionInfoBasedOnId(data.displaypromotionContents);
                });
            }
        });
    }

    getPromotionContentV2(productType, promotionType) {
        const vm = this;
        const { user } = vm.props;
        const { promotionSettings } = vm.state.compSettings;

        let extraAction = {
            handleRemainingTime: true,
            getAvailablePromotionTypesFromFinalPromotions: true,
        };

        window.SPL_Content.getPromotionContentV2(vm.props, promotionSettings, productType, promotionType, extraAction)
            .then((data) => {
                let chkProviderWalletField = false;
                let allCategory = {
                    promotionType: 'ALL',
                    desc: 'promotion:promotion.category.all',
                };
                data.promotionTypes.unshift(allCategory);

                // if detect the formFields contain provider_wallet, then call provider_wallet api
                // provider_wallet => optionalFields, Note: required enable in merchant_settings
                for (let i = 0; i < data.displaypromotionContents.length; i++) {
                    let promotionContent = data.displaypromotionContents[i];
                    if (user.isLogin && !chkProviderWalletField && promotionContent.formFields && promotionContent.formFields.includes('PROVIDER_WALLET')) {
                        chkProviderWalletField = true;
                        this.getAllProviderWallets();
                    }
                }

                vm.setState({ promotionList: data }, () => {
                    this.showPromotionInfoBasedOnId(data.displaypromotionContents);
                });
            })
            .catch(() => {});
    }

    showPromotionInfoBasedOnId = (data) => {
        let urlParam = window.SPL_Content.parse_query_string();

        if (urlParam && urlParam.promoId) {
            let promoId = '';

            if (data) {
                for (let i = 0; i < data.length; i++) {
                    if (data[i].parentId) {
                        promoId = data[i].parentId;
                    } else {
                        promoId = data[i].id;
                    }

                    if (urlParam.promoId.toString() === promoId.toString()) {
                        this.toggleDetailModal(data[i]);
                    }
                }
            }
        }
    };

    filterPromotion(data) {
        return data.promotionType.toLowerCase() !== 'winner';
    }

    componentWillUnmount() {
        this.isMount = false;
    }

    toggle(tab) {
        this.onTabClick(tab);
        this.setState({
            activeTab: tab,
        });
    }

    toogleDropdown = () => {
        this.setState({ dropDown: !this.state.dropDown });
    };

    loadAsyncProviderWallet = () => {
        if (this.isMount) {
            this.setState({ isLoad: true }, () => {
                window.SPL_Provider.loadAsyncProviderWallet(null, this.props).then((providerWallet) => {
                    let providerList = this.state.providerList;
                    for (let i = 0; i < providerList.length; i++) {
                        let results = providerWallet.providerList.filter(function (e) {
                            return e.provider === providerList[i].provider;
                        })[0];

                        if (results) {
                            providerList[i].balance = results.balance ? results.balance : 0;
                            providerList[i].serverIsUnderMaintenance = results.serverIsUnderMaintenance;
                            providerList[i].isdisplay = true;
                            providerList[i].serverMaintenanceStr = results.serverIsUnderMaintenance ? 'error:error.underMaintainance' : '';
                        } else {
                            providerList[i].serverMaintenanceStr = '';
                        }
                    }
                    if (this.isMount) {
                        this.setState({ providerList: providerList });
                    }
                });
            });
        }
    };

    handleAmountChange = (event) => {
        let value = event.target.value;

        if (value) {
            if (value.toString().match(/^(\d*)\.{0,1}(\d){0,2}$/)) {
                this.setState({ transferAmount: value }, () => {
                    // this.getPromoDetails(this.state.promoDetails);
                    if (value > this.state.transferSliderMax) {
                        this.setState({ transferAmount: this.state.transferSliderMax });
                    }
                });
            }
        } else {
            this.setState({ transferAmount: 0 }, () => {
                this.getPromoDetails(this.state.promoDetails);
            });
        }
    };

    handleProviderSelect = (provider, img, balance) => {
        let redirect = null;

        if (provider === 'AG2') {
            redirect = '/casino/asia-gaming-2';
        } else if (provider === 'MEGA') {
            redirect = '/mega888';
        } else if (provider === 'MGP') {
            redirect = '/slots/microGamingPlus';
        } else if (provider === 'SG') {
            redirect = '/slots/spadeGaming';
        } else if (provider === 'SA') {
            redirect = '/casino/sa-gaming';
        } else if (provider === 'SCR2') {
            redirect = '/918kiss';
        } else if (provider === 'PT2') {
            redirect = '/slots/playTech';
        } else if (provider === 'EBET') {
            redirect = '/casino/ebet';
        } else if (provider === 'TTG') {
            redirect = '/slots/toptrendgaming';
        } else if (provider === 'UL') {
            redirect = '/ultimate-slots';
        } else if (provider === 'GP') {
            redirect = '/slots/gameplay';
        } else if (provider === 'AB') {
            redirect = '/casino/allbet';
        } else if (provider === 'GD') {
            redirect = '/casino/gold-deluxe';
        } else if (provider === 'QQK') {
            redirect = '/qqkeno';
        } else if (provider === 'DG') {
            redirect = '/casino/dream-gaming';
        } else if (provider === 'UG' || provider === 'AES' || provider === 'AES2') {
            redirect = '/casino/sexy-baccarat';
        } else if (provider === 'CMD') {
            redirect = '/cmd368';
        } else if (provider === 'BR') {
            redirect = '/virtualsports-landing';
        } else if (provider === 'IDN') {
            redirect = '/poker';
        } else if (provider === 'SBO') {
            redirect = '/sbo';
        } else if (provider === 'EVO') {
            redirect = '/casino/evolution-gaming';
        } else if (provider === 'PG') {
            redirect = '/slots/playNGo';
        } else if (provider === 'PP') {
            redirect = '/slots/pragmaticPlay';
        } else if (provider === 'UFA') {
            redirect = '/ufa';
        } else {
            redirect = '/';
        }

        this.setState({ selectedProvider: provider, selectedProviderImage: img, selectedProviderBalance: balance, redirectLink: redirect });
    };

    restoreWallet = () => {
        this.setState({ restoreOnLoad: true });
        window.SPL_Transaction.transferAllBackMainWallet()
            .then(() => {
                setTimeout(() => {
                    this.getMainWallet();
                    this.setState({ restoreOnLoad: false });
                }, 5000);
            })
            .catch(() => {
                setTimeout(() => {
                    this.setState({ restoreOnLoad: false });
                    this.getMainWallet();
                }, 5000);
            });
    };

    getAllProviderWallets = () => {
        let vm = this;
        window.SPL_Provider.getAllProviderWalletList(null, false, this.props).then((data) => {
            if (data && data.providerList) {
                core.portalIsLoading(vm.props, true);
                let providerWalletsList = data.providerList.filter((e) => e.provider);
                this.setState(
                    {
                        providerWalletsList: providerWalletsList,
                    },
                    () => {
                        core.portalIsLoading(vm.props, false);
                    }
                );
            }
        });
    };

    renderCountdown = ({ days, hours, minutes, seconds, completed, props }) => {
        const { customTranslationObj } = props.props.state;

        return (
            <Translation>
                {(t) => (
                    <div className='time-container'>
                        <div className='day-box'>
                            <p className='day-number'>{!completed ? zeroPad(days) : '00'}</p>
                            <p className='day-text'>
                                {customTranslationObj && customTranslationObj.day ? customTranslationObj.day : t('global:global.messages.maintenance.day', 'Days')}
                            </p>
                        </div>

                        <div className='time-box-container'>
                            <div className='time-box'>
                                <p className='time-hour'>{!completed ? zeroPad(hours) : '00'}</p>
                                <p className='time-text'>
                                    {customTranslationObj && customTranslationObj.hour ? customTranslationObj.hour : t('global:global.messages.maintenance.hour', 'Hours')}
                                </p>
                            </div>
                        </div>
                    </div>
                )}
            </Translation>
        );
    };

    render() {
        const { displaypromotionContents, promotionTypes } = this.state.promotionList;
        const { transModal, promotionObj, mainWallet } = this.state;

        const { msgTitle, msgContent, detailModal, loginModal, applyContent, providerWalletsList, promoContent } = this.state;

        let modalMsg = {
            msgTitle: msgTitle,
            msgContent: msgContent,
            detailModal: detailModal,
            loginModal: loginModal,
            applyContent: applyContent,
            providerWalletsList: providerWalletsList,
            promoContent: promoContent,

            toggleDetailModal: this.toggleDetailModal,
            toggleFormModal: this.toggleFormModal,
            renderCountdown: this.renderCountdown,
        };
        return (
            <Translation>
                {(t) => (
                    <MainLayout>
                        {this.state.isPopUp && (
                            <div className='invalid-feedback text-success success-popup'>
                                <div className='success-popup-body direct-popup'>
                                    <MdClose onClick={() => this.setState({ isPopUp: false, message: '', status: '' })} />
                                    {this.state.status === 'S' ? (
                                        <span>
                                            <Trans className='success-popup-msg' i18nKey={this.state.message}></Trans>
                                        </span>
                                    ) : this.state.status === 'F' ? (
                                        <span className='invalid-feedback text-danger'>
                                            <Trans i18nKey={this.state.message}></Trans>
                                        </span>
                                    ) : null}
                                </div>
                            </div>
                        )}
                        <div className='favourite-container content-container'>
                            {this.state.detailModal && <MessagePopUp modalMsg={modalMsg} />}

                            {this.state.formModal && <FormPopUp modalMsg={modalMsg} formModal={this.state.formModal} />}

                            <div className='content-section'>
                                <ul className='home-content-section'>
                                    <li className='content-promopage '>
                                        <div>
                                            <div className='content-center-box'>
                                                <div className='content-center'>
                                                    <Nav tabs className='promotion-nav-tab'>
                                                        {(promotionTypes || []).map((type, index) => {
                                                            return (
                                                                type.desc && (
                                                                    <NavItem
                                                                        key={index}
                                                                        className={`promo-tab-item ${type.promotionType === this.state.activeTab ? 'active' : ''}`}
                                                                    >
                                                                        <NavLink
                                                                            className={`promo-nav-link ${type.promotionType === this.state.activeTab ? 'active' : ''} `}
                                                                            onClick={() => {
                                                                                this.onTabClick(index);
                                                                            }}
                                                                        >
                                                                            <div className='promo-tab-inner'>
                                                                                <div className='promo-header-text'>{t(type.desc)}</div>
                                                                            </div>
                                                                        </NavLink>
                                                                    </NavItem>
                                                                )
                                                            );
                                                        })}
                                                    </Nav>
                                                    {displaypromotionContents && displaypromotionContents.length > 0 ? (
                                                        <div className='promo-list'>
                                                            {(displaypromotionContents || []).map((content, contentIndex) => {
                                                                return (
                                                                    <div className='promotion-container' key={content.id}>
                                                                        {content && content.image && content.image.length > 0 && (
                                                                            <div className='promotion-image'>
                                                                                <LazyLoadImage src={content.image} alt='promotion' />
                                                                            </div>
                                                                        )}
                                                                        {!(content && content.image && content.image.length > 0) && (
                                                                            <div className='promotion-image'>
                                                                                <div className='w-100'></div>
                                                                            </div>
                                                                        )}
                                                                        <div className='promotion-content-detail'>
                                                                            <div className='promotion-text-container'>
                                                                                <div className='promotion-content-title'>{content.title}</div>
                                                                                <span className=' promotion-content-detail-desc'>{content.description}</span>
                                                                            </div>
                                                                            <div className='promotion-btn-container'>
                                                                                <div className='promotion-btn-group'>
                                                                                    <button
                                                                                        className='btn-normal btn-promo-details'
                                                                                        onClick={() => this.toggleDetailModal(content)}
                                                                                    >
                                                                                        {t('promotion:promotion.button')}
                                                                                    </button>
                                                                                    <button
                                                                                        className={`btn-normal btn-promoapply ${
                                                                                            content.isAllowApply ? 'apply-show' : 'apply-hide'
                                                                                        } `}
                                                                                        onClick={() => this.toggleFormModal(content)}
                                                                                    >
                                                                                        {t('promotion:promotion.apply')}
                                                                                    </button>
                                                                                </div>

                                                                                {content.isRemainingTime && (
                                                                                    <div className='countdown-container'>
                                                                                        <p className='remaining-time'>
                                                                                            {t('promotion:promotion.remainingTime', 'Remaining Time')} :{' '}
                                                                                        </p>

                                                                                        {content.remainingUnlimited ? (
                                                                                            <div className='countdown-container'>
                                                                                                {t('promotion:promotion.unlimited', 'Unlimited')}
                                                                                            </div>
                                                                                        ) : (
                                                                                            <Countdown
                                                                                                props={this}
                                                                                                date={Date.now() + moment(new Date(content.endDate)).diff(moment(Date.now()))}
                                                                                                renderer={(props) => this.renderCountdown(props)}
                                                                                            />
                                                                                        )}
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                    ) : (
                                                        <div className='no-Data'>{t('promotion:promotion.no-promo', 'No Promotion')}</div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>

                            {/* --------------------------------- Promotion New Apply Modal ----------------------------------- */}
                            {transModal && (
                                <div className='messaging-popup promo-transferprovider-modal'>
                                    {this.state.showLoading && <Loading />}
                                    <div className='popup'>
                                        <div className='popup-header'>
                                            <div className='popup-header-left'>
                                                <div className='popup-title'>{promotionObj.title}</div>
                                            </div>
                                            <div className='popup-header-right'>
                                                <MdClose onClick={() => this.setState({ transModal: false })} />
                                            </div>
                                        </div>
                                        <div className='popup-body'>
                                            {/* --------------- Promo Wallet --------------- */}
                                            <ul className='promo-wallet'>
                                                <li className='wallet'>
                                                    <div className='main-wallet'>
                                                        {!this.props.screen.isMobile && <SVGMyAcc name='transferall' className='promo-icon-wallet' />}
                                                        <div className='wallet-info'>
                                                            <span className='mainWallet-title'>{t('global:global.form.mainWallet')}</span>
                                                            {mainWallet && <span className='mainWallet-amount'>{window.SPL_Other.formatAmount(mainWallet.balance)}</span>}
                                                            <span className='mainWallet-currency'>{this.props.user.account.currency}</span>
                                                        </div>
                                                        {this.state.restoreOnLoad ? (
                                                            <SmallLoading></SmallLoading>
                                                        ) : (
                                                            <div className='promo-icon-restore' onClick={() => this.restoreWallet()}>
                                                                <SVGMaster name='promorestore' />
                                                            </div>
                                                        )}
                                                    </div>
                                                    <IoMdArrowRoundDown className='promo-icon-arrow' />
                                                    <div className='provider-wallet'>
                                                        <img
                                                            onClick={this.props.screen.isMobile ? this.toogleDropdown : null}
                                                            className='provider-selected'
                                                            src={this.state.selectedProviderImage}
                                                        />
                                                        {!this.props.screen.isMobile && (
                                                            <div className='wallet-info'>
                                                                <span>{window.SPL_Other.formatAmount(this.state.selectedProviderBalance)}</span>
                                                                <span>{this.state.selectedProvider} Wallet</span>
                                                            </div>
                                                        )}

                                                        {this.state.dropDown && (
                                                            <div className='provider-list'>
                                                                {this.state.providerList.map(
                                                                    (provider) =>
                                                                        provider.name && (
                                                                            <img
                                                                                key={provider.provider}
                                                                                onClick={() => {
                                                                                    this.handleProviderSelect(
                                                                                        provider.provider,
                                                                                        `/public/images/promotion-transfer/${provider.provider}.png`,
                                                                                        provider.balance
                                                                                    );
                                                                                    this.toogleDropdown();
                                                                                }}
                                                                                className='provider-icon'
                                                                                src={`/public/images/promotion-transfer/${provider.provider}.png`}
                                                                            />
                                                                        )
                                                                )}
                                                            </div>
                                                        )}
                                                    </div>
                                                </li>
                                                <li className='amount'>
                                                    <span className='amount-title'>{t('popupTransfer:popupTransfer.transferAmount')}</span>
                                                    <input
                                                        type='number'
                                                        className='amount-input'
                                                        id='transferamount'
                                                        value={this.state.transferAmount}
                                                        onChange={this.handleAmountChange}
                                                    />
                                                    <div className='amount-range'>
                                                        <input
                                                            type='range'
                                                            className='range-box'
                                                            min={this.state.transferSliderMin}
                                                            max={this.state.transferSliderMax}
                                                            value={this.state.transferAmount}
                                                            onChange={(e) => this.handleSliderChange(e.target.value)}
                                                        />
                                                        <span className='amount-info'>
                                                            {this.props.user.account.currency} {this.state.transferAmount}
                                                        </span>
                                                    </div>
                                                </li>
                                                <li className='turnover-bonus'>
                                                    <div className='turnover'>
                                                        <label>
                                                            Target Turnover <span>:</span>
                                                        </label>
                                                        <span>{this.state.targetTurnover}</span>
                                                    </div>
                                                    <div className='bonus'>
                                                        <label>
                                                            Bonus <span>:</span>
                                                        </label>
                                                        <span>{this.state.bonusAmount}</span>
                                                    </div>
                                                </li>
                                            </ul>

                                            {/* --------------- Promo Provider --------------- */}
                                            {!this.props.screen.isMobile && (
                                                <ul className='promo-provider'>
                                                    <li className='provider-title'>Select Provider</li>
                                                    <li className='provider-list'>
                                                        {this.state.providerList.map((provider) => (
                                                            <img
                                                                key={provider.id}
                                                                onClick={() => {
                                                                    this.handleProviderSelect(
                                                                        provider.provider,
                                                                        `/public/images/promotion-transfer/${provider.provider}.png`,
                                                                        provider.balance
                                                                    );
                                                                }}
                                                                className='provider-icon'
                                                                src={`/public/images/promotion-transfer/${provider.provider}.png`}
                                                            />
                                                        ))}
                                                    </li>
                                                </ul>
                                            )}
                                        </div>
                                        <div className='popup-footer'>
                                            <span className='btn-normal btn-body' onClick={() => this.requestTransfer()}>
                                                {t('promotion:promotion.apply')}
                                            </span>
                                        </div>
                                    </div>
                                    <div className='popup-overlay' onClick={() => this.setState({ transModal: false })}></div>
                                </div>
                            )}
                        </div>
                    </MainLayout>
                )}
            </Translation>
        );
    }
}
export default connect(mapStateToProps)(withTranslation(['promotion', 'popupTransfer'])(withRouter(Promotion)));
